
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Deben Admin';

  constructor(public _translate: TranslateService,
    @Inject(DOCUMENT) private document: Document) {

  }

  ngOnInit() {
    let lang = localStorage.getItem('language') || 'en'
    this.defaultLanguage(lang);
    this.setPageDirection(lang)
  }

  setPageDirection(val = 'en') {
    this.document.documentElement.dir = ((val == 'en') ? 'ltr' : 'rtl');
    this.document.documentElement.lang = ((val == 'en') ? 'en' : 'ar');
  }

  defaultLanguage(lang: any = 'en') {
    this._translate.setDefaultLang(lang || 'en');
    this._translate.use(lang || 'en');
    localStorage.setItem('language', lang || 'en');
  }
}
